module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close"},"fi":{"close":"Sulje"},"sv":{"close":"Stäng"},"de":{"close":"Schließen"},"ko":{"close":"닫기"}}')
  delete Component.options._Ctor
}
